import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
import { useQuery } from '@apollo/client/react'
import { useRouter } from 'hooks/useRouter'
// components
import PlanTypeEdit from 'components/PageComponents/Settings/PlanTypes/Edit'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
import DeletePlanTypeButton from 'components/PageComponents/Settings/PlanTypes/Edit/DeleteButton'
import { Container } from '@mui/material'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// context
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'
// types
import { IPlanType } from 'types/graphql'
// themes
import { SettingsIcon } from 'themes/views/settings'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// graphql
import { PLAN_TYPES_DETAILS_QUERY } from 'graphql/planType/queries'
// utils
import get from 'lodash/get'

const PlanTypeEditSettingsPage = () => {
  const router = useRouter()

  const { data: entityQuery, loading } = useQuery(PLAN_TYPES_DETAILS_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      filter: { ids: [router.query.id] }
    }
  })

  const planType: IPlanType = get(entityQuery, 'planTypes.data[0]')

  return (
    <>
      <Helmet>
        <title>Skefto - Plan Type Edit</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={loading}
        label={
          <>
            <SettingsIcon />
            Plan Type
          </>
        }
        CTA={
          <>
            <Button layout={BUTTON_LAYOUTS.PURPLE} onClick={() => router.back()} type='button'>
              Back
            </Button>
            <DeletePlanTypeButton />
          </>
        }>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <Container maxWidth={false}>
            <PlanTypeEdit planType={planType} />
          </Container>
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default PlanTypeEditSettingsPage
